<div class="account-section">
  <div class="my-section-box">
    <div class="my-section-box__headline">{{'dataExtractionRquest.eCUInformation'|cxTranslate}}
    </div>
    <form [formGroup]="form" class="dtc-form">
      <!-- Header: Diagnostic Trouble Code (DTC) Report -->
      <section class="section-header">
        <div class="section-title">
          <span class="label">{{'ECUForm.dtc_report_text'|cxTranslate}}</span>
        </div>

        <div class="actions">
          <button type="button" class="btn btn-primary view-add-btn" (click)="uploadFile(0)">
            {{'common.text_warranty_view_add_information'|cxTranslate}}
          </button>
          <span *ngIf="fileLength$|async as filecount ; else noFiles" class="record-count">{{ filecount }}
            {{'ECUForm.record_text'|cxTranslate}}</span>
          <!-- </div> -->
          <ng-template #noFiles>
            <span class="record-count">{{'common.text_warranty_view_max_mb'|cxTranslate}}</span>
          </ng-template>
          <img class="info-icon info-dtc" src="icons/question_dark_kb.svg" alt="Info" (click)="openPopupDTC()" />
        </div>
      </section>

      <!-- ECU(s) Removed - Check All That Apply -->
      <section class="section-ecus">
        <div class="section-title">
          <span class="label">{{'ECUForm.ecu_removed'|cxTranslate}}</span>
          <!-- <span class="required">*</span> -->
        </div>

        <!-- Grid with 3 ECU rows matching the screenshot -->

        <div class="ecu-grid">

          <!-- Row: Bendix ABS ECU -->

          <div class="ecu-row">
            <!-- Checkbox + Text -->
            <label class="col col-check checkbox">
              <input type="checkbox" formControlName="ecu_abs"
                (change)="checkboxChange($event, 'ecu_abs', 'abs_serial', 'Bendix® ABS ECU')" />
              <span #labelA class="ecu-name"><strong>{{'ECUForm.bendix_ABS_text'|cxTranslate}}</strong></span>
            </label>

            <!-- Images -->
            <div class="col col-images">
              <div class="ecu-images">
                <img src="images/BDR EC-80 ECU Cluster.png" alt="ABS ECU 1" />
              </div>
            </div>

            <!-- Serial Number (visible only when checked) -->
            <div class="col col-serial" *ngIf="form.get('ecu_abs')?.value">
              <label class="field-label">
                {{'ECUForm.ecu_serial_no'|cxTranslate}}
                <img class="info-icon" src="icons/question_dark_kb.svg" alt="Info" (click)="openPopupSerialNumber()" />
              </label>
              <input type="text" formControlName="abs_serial"
                (input)="checkboxChange($event, 'ecu_abs', 'abs_serial','Bendix® ABS ECU')"
                [ngClass]="{ 'is-valid':(form?.get('abs_serial')?.dirty || submitted) && !form?.get('abs_serial')?.errors, 
                                                    'is-invalid': (form?.get('abs_serial')?.dirty || submitted) && form?.get('abs_serial')?.errors }" />
              <div class="invalid-feedback-icon" *ngIf="
                                               form.get('abs_serial')?.invalid &&
                                               (form.get('abs_serial')?.dirty ||
                                                form.get('abs_serial')?.touched ||
                                                submitted)
                                             ">
                {{'dataExtractionRquest.error_message'|cxTranslate}}
              </div>
            </div>

            <!-- ECU Photo (visible only when checked) -->
            <div class="col col-photo" *ngIf="form.get('ecu_abs')?.value">
              <label class="field-label">{{'ECUForm.ecu_photo'|cxTranslate}}
                <img class="info-icon info-photo" src="icons/question_dark_kb.svg" alt="Info"
                  (click)="openPopupECUPhoto()" />
              </label>
              <div class="file-actions">
                <button type="button" class="btn btn-primary view-add-btn"
                  (click)="ABSPhotoUpload(0)">{{'common.text_warranty_view_add_information'|cxTranslate}}</button>
                <div *ngIf="fileLengthABS$|async as filecountABS ; else noFiles">
                  <span class="record-count">{{ filecountABS }} {{'ECUForm.record_text'|cxTranslate}}</span>
                </div>
                <ng-template #noFiles>
                  <span class="record-count">{{'common.text_warranty_view_max_mb'|cxTranslate}}</span>
                </ng-template>
              </div>
            </div>
          </div>

          <!-- Repeat block above for other ECUs -->
          <div class="ecu-row">
            <label class="col col-check checkbox">
              <input type="checkbox" formControlName="ecu_ebs90"
                (change)="checkboxChange($event, 'ecu_ebs90', 'ebs90_serial', 'Bendix® EBS-90™ ECU')" />
              <span #labelB class="ecu-name"><strong>{{'ECUForm.bendix_EBS_Text'|cxTranslate}}</strong></span>
            </label>
            <div class="col col-images">
              <div class="ecu-images">
                <img src="images/BDR EBS-90 ECU Cluster.png" alt="EBS-90 ECU 1" />
              </div>
            </div>
            <div class="col col-serial" *ngIf="form.get('ecu_ebs90')?.value">
              <label class="field-label">
                {{'ECUForm.ecu_serial_no'|cxTranslate}}
                <img class="info-icon" src="icons/question_dark_kb.svg" alt="Info" (click)="openPopupSerialNumber()" />
              </label>
              <input type="text" formControlName="ebs90_serial"
                (input)="checkboxChange($event, 'ecu_ebs90', 'ebs90_serial','Bendix® EBS-90™ ECU')"
                [ngClass]="{ 'is-valid':(form?.get('ebs90_serial')?.dirty || submitted) && !form?.get('ebs90_serial')?.errors, 
                                                    'is-invalid': (form?.get('ebs90_serial')?.dirty || submitted) && form?.get('ebs90_serial')?.errors }" />
              <div class="invalid-feedback-icon" *ngIf="
                                               form.get('ebs90_serial')?.invalid &&
                                               (form.get('ebs90_serial')?.dirty ||
                                                form.get('ebs90_serial')?.touched ||
                                                submitted)
                                             ">
                {{'dataExtractionRquest.error_message'|cxTranslate}}
              </div>
            </div>
            <div class="col col-photo" *ngIf="form.get('ecu_ebs90')?.value">
              <label class="field-label">{{'ECUForm.ecu_photo'|cxTranslate}}
                <img class="info-icon info-photo" src="icons/question_dark_kb.svg" alt="Info"
                  (click)="openPopupECUPhoto()" />
              </label>
              <div class="file-actions">
                <button type="button" class="btn btn-primary view-add-btn"
                  (click)="EBSPhotoUpload(0)">{{'common.text_warranty_view_add_information'|cxTranslate}}</button>
                <div *ngIf="fileLengthEBS$|async as filecountEBS ; else noFiles">
                  <span class="record-count">{{ filecountEBS }} {{'ECUForm.record_text'|cxTranslate}}</span>
                </div>
                <ng-template #noFiles>
                  <span class="record-count">{{'common.text_warranty_view_max_mb'|cxTranslate}}</span>
                </ng-template>
              </div>
            </div>
          </div>


  <!-- Repeat block above for other LCUs -->
          <div class="ecu-row">
            <label class="col col-check checkbox">
              <input type="checkbox" formControlName="ecu_flc20_black"
                (change)="checkboxChange($event, 'ecu_flc20_black', 'flc20_black_serial', 'Bendix® FLC-20™ Camera (Black)')" />
              <span #labelC class="ecu-name"><strong>{{'ECUForm.bendix_FLC_text'|cxTranslate}}</strong></span>
            </label>
            <div class="col col-images">
              <div class="ecu-images">
                <img src="images/BDR FLC-20 Camera Cluster.png" alt="FLC-20 Black 1" />
              </div>
            </div>
            <div class="col col-serial" *ngIf="form.get('ecu_flc20_black')?.value">
              <label class="field-label">
                {{'ECUForm.ecu_serial_no'|cxTranslate}}
                <img class="info-icon" src="icons/question_dark_kb.svg" alt="Info" (click)="openPopupSerialNumber()" />
              </label>
              <input type="text" formControlName="flc20_black_serial"
                (input)="checkboxChange($event, 'ecu_flc20_black', 'flc20_black_serial','Bendix® FLC-20™ Camera (Black)')"
                [ngClass]="{ 'is-valid':(form?.get('flc20_black_serial')?.dirty || submitted) && !form?.get('flc20_black_serial')?.errors, 
                                                    'is-invalid': (form?.get('flc20_black_serial')?.dirty || submitted) && form?.get('flc20_black_serial')?.errors }" />
              <div class="invalid-feedback-icon" *ngIf="
                                               form.get('flc20_black_serial')?.invalid &&
                                               (form.get('flc20_black_serial')?.dirty ||
                                                form.get('flc20_black_serial')?.touched ||
                                                submitted)
                                             ">
                {{'dataExtractionRquest.error_message'|cxTranslate}}
              </div>
            </div>
            
            <div class="col col-photo" *ngIf="form.get('ecu_flc20_black')?.value">
              <label class="field-label">{{'ECUForm.ecu_photo'|cxTranslate}}
                <img class="info-icon info-photo" src="icons/question_dark_kb.svg" alt="Info"
                  (click)="openPopupECUPhoto()" />
              </label>
              <div class="file-actions">
                <button type="button" class="btn btn-primary view-add-btn"
                  (click)="FLCPhotoUpload(0)">{{'common.text_warranty_view_add_information'|cxTranslate}}</button>
                <div *ngIf="fileLengthFLC$|async as filecountFLC ; else noFiles">
                  <span class="record-count">{{ filecountFLC }} {{'ECUForm.record_text'|cxTranslate}}</span>
                </div>
                <ng-template #noFiles>
                  <span class="record-count">{{'common.text_warranty_view_max_mb'|cxTranslate}}</span>
                </ng-template>
              </div>
            </div>
          </div>
          
<!-- Repeat block above for other DECU -->

 <div class="ecu-row">
            <label class="col col-check checkbox">
              <input type="checkbox" formControlName="ecu_intellipark_dash"
                (change)="checkboxChange($event, 'ecu_intellipark_dash', 'intellipark_dash_serial', 'Bendix® Intellipark® Dash ECU (DECU)')" />
              <span #labelD class="ecu-name"><strong>{{'ECUForm.bendix_intellipark_text'|cxTranslate}}</strong></span>
            </label>

            <div class="col col-images">
              <div class="decu-images">
                <img src="images/Intellipark DECU Cluster (no background).png" alt="ECU DASH 1" />
              </div>
            </div>

            <div class="col col-serial" *ngIf="form.get('ecu_intellipark_dash')?.value">
              <label class="field-label">
                {{'ECUForm.ecu_serial_no'|cxTranslate}}
                <img class="info-icon" src="icons/question_dark_kb.svg" alt="Info" (click)="openPopupSerialNumber()" />
              </label>

              <input type="text" formControlName="intellipark_dash_serial"
                (input)="checkboxChange($event, 'ecu_intellipark_dash', 'intellipark_dash_serial','Bendix® Intellipark® Dash ECU (DECU)')"
                [ngClass]="{ 'is-valid':(form?.get('intellipark_dash_serial')?.dirty || submitted) && !form?.get('intellipark_dash_serial')?.errors, 
                                                    'is-invalid': (form?.get('intellipark_dash_serial')?.dirty || submitted) && form?.get('intellipark_dash_serial')?.errors }" />
              <div class="invalid-feedback-icon" *ngIf="
                                               form.get('intellipark_dash_serial')?.invalid &&
                                               (form.get('intellipark_dash_serial')?.dirty ||
                                                form.get('intellipark_dash_serial')?.touched ||
                                                submitted)
                                             ">
                {{'dataExtractionRquest.error_message'|cxTranslate}}
              </div>
            </div>

            <div class="col col-photo" *ngIf="form.get('ecu_intellipark_dash')?.value">
              <label class="field-label">{{'ECUForm.ecu_photo'|cxTranslate}}
                <img class="info-icon info-photo" src="icons/question_dark_kb.svg" alt="Info"
                  (click)="openPopupECUPhoto()" />
              </label>
              <div class="file-actions">
                <button type="button" class="btn btn-primary view-add-btn"
                  (click)="intelliparkPhotoUpload(0)">{{'common.text_warranty_view_add_information'|cxTranslate}}</button>
                <div *ngIf="fileLengthIntellipark$|async as filecountIntellipark ; else noFiles">
                  <span class="record-count">{{ filecountIntellipark }} {{'ECUForm.record_text'|cxTranslate}}</span>
                </div>
                <ng-template #noFiles>
                  <span class="record-count">{{'common.text_warranty_view_max_mb'|cxTranslate}}</span>
                </ng-template>
              </div>
            </div>

          </div>




        </div>
      </section>

      <!-- Additional devices + notes (unchanged) -->
      <section class="section-not-send">
        <div class="device-row">
          <label class="checkbox">
            <input type="checkbox" formControlName="sdp" />
            <span class="row-text">{{'ECUForm.sdp_text'|cxTranslate}}</span>
          </label>
          <div class="note red sdp" [innerHTML]="'ECUForm.not_send_bendix_text' | cxTranslate">
          </div>
        </div>

        <div class="device-row">
          <label class="checkbox">
            <input type="checkbox" formControlName="autoVue_ecu" />
            <span class="row-text">{{'ECUForm.ecu_text'|cxTranslate}}</span>
          </label>
          <div class="note red ecu" [innerHTML]="'ECUForm.not_send_bendix_text' | cxTranslate">
          </div>
        </div>

        <div class="device-row">
          <label class="checkbox">
            <input type="checkbox" formControlName="autoVue_3g_camera" />
            <span class="row-text">{{'ECUForm.camera_text'|cxTranslate}}</span>
          </label>
          <div class="note red camera" [innerHTML]="'ECUForm.not_send_ecu_text' | cxTranslate">
          </div>
        </div>

        <div class="device-row">
          <label class="checkbox">
            <input type="checkbox" formControlName="flr21_flr25" />
            <span class="row-text">{{'ECUForm.flr_text'|cxTranslate}}</span>
          </label>
          <div class="note red flr" [innerHTML]="'ECUForm.not_send_ecu_text' | cxTranslate">
          </div>
        </div>
      </section>

      <div class="data-extraction__form">
        <div class="my-section-box-inner">
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <label for="ecuremovedvehiclename" class="control-label">ECUs Removed from Vehicle by Name*</label>
              <input type="text" class="form-control" formControlName="ecuremovedvehiclename"
                [ngClass]="{ 'is-valid':(form?.get('ecuremovedvehiclename')?.dirty || submitted) && !form?.get('ecuremovedvehiclename')?.errors, 
                                            'is-invalid': (form?.get('ecuremovedvehiclename').dirty|| submitted) && form?.get('ecuremovedvehiclename')?.errors }" />
              <div class="invalid-feedback">
                <span class="text-danger-show"
                  *ngIf=" form?.get('ecuremovedvehiclename')?.errors && form?.get('ecuremovedvehiclename')?.errors['required']">{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <div class="form-group">
                <label class="control-label">
                  Removal Date*
                </label>
                <span class="warranty-info-dateblock">
                  <input formControlName="removalDate" bsDatepicker [maxDate]="today"
                    [bsConfig]="{ dateInputFormat:'MM/DD/YYYY',showWeekNumbers:false, displayOneMonthRange: true }"
                    placeholder={{localizedDateFormat?.toLowerCase()}}
                    class="form-control warranty-date-picker-class hasDatepicker bsdpicker kb-datePickerIcon removal-date"
                    [ngClass]="{ 'is-valid': (form?.get('removalDate').dirty) &&
                                !form?.get('removalDate').errors, 'is-invalid':
                                (form?.get('removalDate').dirty) &&
                                form?.get('removalDate').errors }">
                  <div class="invalid-feedback">
                    <span class="text-danger-show" *ngIf="form?.get('removalDate')?.errors &&
                                    form?.get('removalDate')?.errors['required']">
                      {{'common.form_field_required'|cxTranslate}}
                    </span>
                  </div>
                </span>
              </div>
            </div>
          </div>

          <div class="row margin-top-25">
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <label for="removalTime" class="control-label">Removal Time</label>
              <input type="time" formControlName="removalTime" class="form-control removal_time" name="removalTime">
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <label for="senderName" class="control-label">Sender Name*</label>
              <input type="text" formControlName="senderName" class="form-control" name="senderName"
                [ngClass]="{ 'is-valid': (form?.get('senderName')?.dirty || submitted) && !form?.get('senderName')?.errors,
                                 'is-invalid': (form?.get('senderName')?.dirty || submitted) && form?.get('senderName')?.errors }">
              <div class="invalid-feedback">
                <span class="text-danger-show"
                  *ngIf=" form?.get('senderName')?.errors && form?.get('senderName')?.errors['required']">{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
              </div>
            </div>
          </div>

          <div class="row margin-top-25 carrier-Name">
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <label for="carrierName" class="control-label">Carrier Name*</label>
              <input type="text" formControlName="carrierName" class="form-control" name="vehicleTruckNumber"
                [ngClass]="{ 'is-valid': (form?.get('carrierName')?.dirty || submitted) && !form?.get('carrierName')?.errors, 'is-invalid': (form?.get('carrierName')?.dirty || submitted) && form?.get('carrierName')?.errors }">
              <div class="invalid-feedback">
                <span class="text-danger-show"
                  *ngIf=" form?.get('carrierName')?.errors && form?.get('carrierName')?.errors['required']">{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <label for="trackingNumber" class="control-label">Tracking Number</label>
              <input type="text" formControlName="trackingNumber" class="form-control" name="trackingNumber">
            </div>
          </div>
          <div class="endsure-btnblock">
            <button class="btn-action btn-back mt-4" (click)="back()">
              <img src="/icons/link_left_white.svg" class="next-icon-right default-icon" alt="Back">
              {{ 'dataExtractionRquest.back' | cxTranslate }}</button>

            <button class="btn-action btn-next mt-4" (click)="next()"
              [disabled]="!form.valid">{{'dataExtractionRquest.Next'|cxTranslate}}
              <img src="/icons/link-white.svg" class="next-icon-right default-icon" alt="Next">
            </button>

          </div>
        </div>
      </div>


    </form>
  </div>
</div>

<ng-template #popUpBoxFileUpload>
  <div id="warranty-submit-block0" class="warranty-submit-upload">
    <div class="popup-upload-headline">
      <h3>{{ 'common.text_warranty_upload_file' | cxTranslate }}</h3>
      <button class="btn btn-link upload-close" (click)="closePopUpBoxFileUpload()"></button>
    </div>
    <div class="popup-upload-body">
      <p class="attach-body-heading">
        {{ 'ECUForm.text_ecu_select_file_wish' | cxTranslate }}
      </p>
      <div class="popup-upload-wrapper files" id="files0">
        <input type="hidden" class="hiddenLoopIndex" value="0" aria-hidden="true">
        <div *ngIf="isUploadfileSuccess" class="popup-alert-msg files-success-alert">
          <img src="/images/info-green.svg" alt="success">
          <span class="text">{{ 'common.text_warranty_select_all_files' | cxTranslate }}</span>
        </div>
        <div *ngIf="isMaxFileSize" class="popup-alert-msg files-danger-alert">
          <img src="/images/info-red.svg" alt="error">
          <span class="text">
            {{ 'common.text_select_you_can_upload' | cxTranslate }}
          </span>
        </div>
        <div *ngIf="isDuplicateFile" class="popup-alert-msg files-danger-alert-duplicate">
          <img src="/images/info-red.svg" alt="info">
          <span class="text">
            {{ 'common.text_warranty_duplicate_file_error' | cxTranslate }}
          </span>
        </div>
        <p>{{ 'common.text_select_you_path_upload' | cxTranslate }}</p>
        <p></p>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-9">
            <!--  <input type="file" #file (input)="fileSelector(file, 'DTC')" accept=".zip,.xml,.html" -->
            <input type="file" #dtcFileInput (change)="fileSelector(dtcFileInput)"
              accept=".zip,.xml,.html,.htm,text/html,application/zip,application/x-zip-compressed,application/xml,text/xml"
              class="form-control warranty-fileUpload warranty-fileUpload-input input-files-part-no" multiple />
            <div class="text-danger" *ngIf="errorMsg">{{ errorMsg }}</div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 upload-btn-block">
            <button class="btn btn-primary blue-btn create-file-data-btn uploadAttachment"
              (click)="fileUploadFunction()" type="button" [disabled]="isAtleastOnefileIsThere">
              {{ 'common.text_warranty_button_uploadFile' | cxTranslate }}
            </button>
          </div>
        </div>
        <div class="warranty-upload-note">
          {{ 'ECUForm.text_ecu_select_file_type_upload' | cxTranslate }}<br>
        </div>
        <div class="popup-upload-fileLists">
          <div *ngIf="fileLength$|async as filecount ; else noFiles" class="upload-fileList-result">
            {{ 'common.text_select_you_record_sets' | cxTranslate }}
            <span class="upload-fileList-result-number">{{ filecount }}</span>
          </div>
          <ng-template #noFiles>
            <div class="upload-fileList-result">
              {{ 'common.text_select_you_record_sets' | cxTranslate }}
              <span class="upload-fileList-result-number">0</span>
            </div>
          </ng-template>
          <ul>
            <li class="hidden-xs hidden-sm">
              <ul class="item__list--header upload-table-labels">
                <li class="item__sort">#</li>
                <li class="item__name">{{ 'common.text_warranty_name' | cxTranslate }}</li>
                <li class="item__size">{{ 'common.text_warranty_size' | cxTranslate }}</li>
                <li class="item__remove"></li>
              </ul>
            </li>
            <li class="item__list--item js-li-container upload-block">
              <ng-container *ngIf="fileCurrentFiles$|async as currentFiles">
                <ul class="fileList" *ngFor="let file of currentFiles;let i= index">
                  <li>
                    <div class="item__sort">{{ i+1 }}</div>
                    <div class="item__name">{{currentFiles[i].name}}</div>
                    <div class="item__size">{{currentFiles[i].size | number : '1.2-2'}}Kb</div>
                    <div class="removeFile">
                      <button class="btn btn-link" (click)="removefile(file)">
                        {{ 'common.text_remove' | cxTranslate }}
                      </button>
                    </div>
                  </li>
                </ul>
              </ng-container>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #popUpBoxABSPhotoUpload>
  <div id="warranty-submit-block0" class="warranty-submit-upload">
    <div class="popup-upload-headline">
      <h3>{{ 'common.text_warranty_upload_file' | cxTranslate }}</h3>
      <button class="btn btn-link upload-close" (click)="closePopUpBoxFileUpload()"></button>
    </div>
    <div class="popup-upload-body">
      <p class="attach-body-heading">
        {{ 'ECUForm.text_ecu_select_file_wish' | cxTranslate }}
      </p>
      <div class="popup-upload-wrapper files" id="files0">
        <input type="hidden" class="hiddenLoopIndex" value="0" aria-hidden="true">
        <div *ngIf="isUploadfileSuccessABS" class="popup-alert-msg files-success-alert">
          <img src="/images/info-green.svg" alt="success">
          <span class="text">{{ 'common.text_warranty_select_all_files' | cxTranslate }}</span>
        </div>
        <div *ngIf="isMaxFileSizeABS" class="popup-alert-msg files-danger-alert">
          <img src="/images/info-red.svg" alt="error">
          <span class="text">
            {{ 'common.text_select_you_can_upload' | cxTranslate }}
          </span>
        </div>
        <div *ngIf="isDuplicateFileABS" class="popup-alert-msg files-danger-alert-duplicate">
          <img src="/images/info-red.svg" alt="info">
          <span class="text">
            {{ 'common.text_warranty_duplicate_file_error' | cxTranslate }}
          </span>
        </div>
        <p>{{ 'common.text_select_you_path_upload' | cxTranslate }}</p>
        <p></p>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-9">
            <!--  <input type="file" #file (input)="fileSelectorABS(file, 'Bendix® ABS ECU')" accept="image/*"
              class="form-control warranty-fileUpload warranty-fileUpload-input input-files-part-no" multiple /> -->
            <input type="file" #absFileInput (change)="fileSelectorABS(absFileInput, 'Bendix® ABS ECU')"
              accept="image/*" class="form-control warranty-fileUpload warranty-fileUpload-input input-files-part-no"
              multiple />

            <div class="text-danger" *ngIf="errorMsg">{{ errorMsg }}</div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 upload-btn-block">
            <button class="btn btn-primary blue-btn create-file-data-btn uploadAttachment"
              (click)="fileUploadFunctionABS()" type="button" [disabled]="isAtleastOnefileIsThereABS">
              {{ 'common.text_warranty_button_uploadFile' | cxTranslate }}
            </button>
          </div>
        </div>
        <div class="warranty-upload-note">
          {{ 'ECUForm.text_ecu_select_file_type_upload_1' | cxTranslate }}<br>
        </div>
        <div class="popup-upload-fileLists">
          <div *ngIf="fileLengthABS$|async as filecountABS ; else noFiles" class="upload-fileList-result">
            {{ 'common.text_select_you_record_sets' | cxTranslate }}
            <span class="upload-fileList-result-number">{{ filecountABS }}</span>
          </div>
          <ng-template #noFiles>
            <div class="upload-fileList-result">
              {{ 'common.text_select_you_record_sets' | cxTranslate }}
              <span class="upload-fileList-result-number">0</span>
            </div>
          </ng-template>
          <ul>
            <li class="hidden-xs hidden-sm">
              <ul class="item__list--header upload-table-labels">
                <li class="item__sort">#</li>
                <li class="item__name">{{ 'common.text_warranty_name' | cxTranslate }}</li>
                <li class="item__size">{{ 'common.text_warranty_size' | cxTranslate }}</li>
                <li class="item__remove"></li>
              </ul>
            </li>
            <li class="item__list--item js-li-container upload-block">
              <ng-container *ngIf="fileCurrentFilesABS$|async as currentFilesABS">
                <ul class="fileList" *ngFor="let file of currentFilesABS;let i= index">
                  <li>
                    <div class="item__sort">{{ i+1 }}</div>
                    <div class="item__name">{{currentFilesABS[i].name}}</div>
                    <div class="item__size">{{currentFilesABS[i].size | number : '1.2-2'}}Kb</div>
                    <div class="removeFile">
                      <button class="btn btn-link" (click)="removefileABS(file)">
                        {{ 'common.text_remove' | cxTranslate }}
                      </button>
                    </div>
                  </li>
                </ul>
              </ng-container>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #popUpBoxEBSPhotoUpload>
  <div id="warranty-submit-block0" class="warranty-submit-upload">
    <div class="popup-upload-headline">
      <h3>{{ 'common.text_warranty_upload_file' | cxTranslate }}</h3>
      <button class="btn btn-link upload-close" (click)="closePopUpBoxFileUpload()"></button>
    </div>
    <div class="popup-upload-body">
      <p class="attach-body-heading">
        {{ 'ECUForm.text_ecu_select_file_wish' | cxTranslate }}
      </p>
      <div class="popup-upload-wrapper files" id="files0">
        <input type="hidden" class="hiddenLoopIndex" value="0" aria-hidden="true">
        <div *ngIf="isUploadfileSuccessEBS" class="popup-alert-msg files-success-alert">
          <img src="/images/info-green.svg" alt="success">
          <span class="text">{{ 'common.text_warranty_select_all_files' | cxTranslate }}</span>
        </div>
        <div *ngIf="isMaxFileSizeEBS" class="popup-alert-msg files-danger-alert">
          <img src="/images/info-red.svg" alt="error">
          <span class="text">
            {{ 'common.text_select_you_can_upload' | cxTranslate }}
          </span>
        </div>
        <div *ngIf="isDuplicateFileEBS" class="popup-alert-msg files-danger-alert-duplicate">
          <img src="/images/info-red.svg" alt="info">
          <span class="text">
            {{ 'common.text_warranty_duplicate_file_error' | cxTranslate }}
          </span>
        </div>
        <p>{{ 'common.text_select_you_path_upload' | cxTranslate }}</p>
        <p></p>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-9">
            <!-- <input type="file" #file (input)="fileSelectorEBS(file, 'Bendix® EBS-90™ ECU')" accept="image/*"
              class="form-control warranty-fileUpload warranty-fileUpload-input input-files-part-no" multiple /> -->
            <input type="file" #ebsFileInput (change)="fileSelectorEBS(ebsFileInput, 'Bendix® ABS ECU')"
              accept="image/*" class="form-control warranty-fileUpload warranty-fileUpload-input input-files-part-no"
              multiple />

            <div class="text-danger" *ngIf="errorMsg">{{ errorMsg }}</div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 upload-btn-block">
            <button class="btn btn-primary blue-btn create-file-data-btn uploadAttachment"
              (click)="fileUploadFunctionEBS()" type="button" [disabled]="isAtleastOnefileIsThereEBS">
              {{ 'common.text_warranty_button_uploadFile' | cxTranslate }}
            </button>
          </div>
        </div>
        <div class="warranty-upload-note">
          {{ 'ECUForm.text_ecu_select_file_type_upload_1' | cxTranslate }}<br>
        </div>
        <div class="popup-upload-fileLists">
          <div *ngIf="fileLengthEBS$|async as filecountEBS ; else noFiles" class="upload-fileList-result">
            {{ 'common.text_select_you_record_sets' | cxTranslate }}
            <span class="upload-fileList-result-number">{{ filecountEBS }}</span>
          </div>
          <ng-template #noFiles>
            <div class="upload-fileList-result">
              {{ 'common.text_select_you_record_sets' | cxTranslate }}
              <span class="upload-fileList-result-number">0</span>
            </div>
          </ng-template>
          <ul>
            <li class="hidden-xs hidden-sm">
              <ul class="item__list--header upload-table-labels">
                <li class="item__sort">#</li>
                <li class="item__name">{{ 'common.text_warranty_name' | cxTranslate }}</li>
                <li class="item__size">{{ 'common.text_warranty_size' | cxTranslate }}</li>
                <li class="item__remove"></li>
              </ul>
            </li>
            <li class="item__list--item js-li-container upload-block">
              <ng-container *ngIf="fileCurrentFilesEBS$|async as currentFilesEBS">
                <ul class="fileList" *ngFor="let file of currentFilesEBS;let i= index">
                  <li>
                    <div class="item__sort">{{ i+1 }}</div>
                    <div class="item__name">{{currentFilesEBS[i].name}}</div>
                    <div class="item__size">{{currentFilesEBS[i].size | number : '1.2-2'}}Kb</div>
                    <div class="removeFile">
                      <button class="btn btn-link" (click)="removefileEBS(file)">
                        {{ 'common.text_remove' | cxTranslate }}
                      </button>
                    </div>
                  </li>
                </ul>
              </ng-container>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #popUpBoxFLCPhotoUpload>
  <div id="warranty-submit-block0" class="warranty-submit-upload">
    <div class="popup-upload-headline">
      <h3>{{ 'common.text_warranty_upload_file' | cxTranslate }}</h3>
      <button class="btn btn-link upload-close" (click)="closePopUpBoxFileUpload()"></button>
    </div>
    <div class="popup-upload-body">
      <p class="attach-body-heading">
        {{ 'ECUForm.text_ecu_select_file_wish' | cxTranslate }}
      </p>
      <div class="popup-upload-wrapper files" id="files0">
        <input type="hidden" class="hiddenLoopIndex" value="0" aria-hidden="true">
        <div *ngIf="isUploadfileSuccessFLC" class="popup-alert-msg files-success-alert">
          <img src="/images/info-green.svg" alt="success">
          <span class="text">{{ 'common.text_warranty_select_all_files' | cxTranslate }}</span>
        </div>
        <div *ngIf="isMaxFileSizeFLC" class="popup-alert-msg files-danger-alert">
          <img src="/images/info-red.svg" alt="error">
          <span class="text">
            {{ 'common.text_select_you_can_upload' | cxTranslate }}
          </span>
        </div>
        <div *ngIf="isDuplicateFileFLC" class="popup-alert-msg files-danger-alert-duplicate">
          <img src="/images/info-red.svg" alt="info">
          <span class="text">
            {{ 'common.text_warranty_duplicate_file_error' | cxTranslate }}
          </span>
        </div>
        <p>{{ 'common.text_select_you_path_upload' | cxTranslate }}</p>
        <p></p>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-9">
            <!--  <input type="file" #file (input)="fileSelectorFLC(file, 'Bendix® FLC-20™ Camera (Black)')" accept="image/*"
              class="form-control warranty-fileUpload warranty-fileUpload-input input-files-part-no" multiple /> -->
            <input type="file" #flcFileInput (change)="fileSelectorFLC(flcFileInput, 'Bendix® ABS ECU')"
              accept="image/*" class="form-control warranty-fileUpload warranty-fileUpload-input input-files-part-no"
              multiple />

            <div class="text-danger" *ngIf="errorMsg">{{ errorMsg }}</div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 upload-btn-block">
            <button class="btn btn-primary blue-btn create-file-data-btn uploadAttachment"
              (click)="fileUploadFunctionFLC()" type="button" [disabled]="isAtleastOnefileIsThereFLC">
              {{ 'common.text_warranty_button_uploadFile' | cxTranslate }}
            </button>
          </div>
        </div>
        <div class="warranty-upload-note">
          {{ 'ECUForm.text_ecu_select_file_type_upload_1' | cxTranslate }}<br>
        </div>
        <div class="popup-upload-fileLists">
          <div *ngIf="fileLengthFLC$|async as filecountFLC ; else noFiles" class="upload-fileList-result">
            {{ 'common.text_select_you_record_sets' | cxTranslate }}
            <span class="upload-fileList-result-number">{{ filecountFLC }}</span>
          </div>
          <ng-template #noFiles>
            <div class="upload-fileList-result">
              {{ 'common.text_select_you_record_sets' | cxTranslate }}
              <span class="upload-fileList-result-number">0</span>
            </div>
          </ng-template>
          <ul>
            <li class="hidden-xs hidden-sm">
              <ul class="item__list--header upload-table-labels">
                <li class="item__sort">#</li>
                <li class="item__name">{{ 'common.text_warranty_name' | cxTranslate }}</li>
                <li class="item__size">{{ 'common.text_warranty_size' | cxTranslate }}</li>
                <li class="item__remove"></li>
              </ul>
            </li>
            <li class="item__list--item js-li-container upload-block">
              <ng-container *ngIf="fileCurrentFilesFLC$|async as currentFilesFLC">
                <ul class="fileList" *ngFor="let file of currentFilesFLC;let i= index">
                  <li>
                    <div class="item__sort">{{ i+1 }}</div>
                    <div class="item__name">{{currentFilesFLC[i].name}}</div>
                    <div class="item__size">{{currentFilesFLC[i].size | number : '1.2-2'}}Kb</div>
                    <div class="removeFile">
                      <button class="btn btn-link" (click)="removefileFLC(file)">
                        {{ 'common.text_remove' | cxTranslate }}
                      </button>
                    </div>
                  </li>
                </ul>
              </ng-container>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #PopUpBoxintelliparkPhotoUpload>
  <div id="warranty-submit-block0" class="warranty-submit-upload">
    <div class="popup-upload-headline">
      <h3>{{ 'common.text_warranty_upload_file' | cxTranslate }}</h3>
      <button class="btn btn-link upload-close" (click)="closePopUpBoxFileUpload()"></button>
    </div>
    <div class="popup-upload-body">
      <p class="attach-body-heading">
        {{ 'ECUForm.text_ecu_select_file_wish' | cxTranslate }}
      </p>
      <div class="popup-upload-wrapper files" id="files0">
        <input type="hidden" class="hiddenLoopIndex" value="0" aria-hidden="true">
        <div *ngIf="isUploadfileSuccessIntellipark" class="popup-alert-msg files-success-alert">
          <img src="/images/info-green.svg" alt="success">
          <span class="text">{{ 'common.text_warranty_select_all_files' | cxTranslate }}</span>
        </div>
        <div *ngIf="isMaxFileSizeIntellipark" class="popup-alert-msg files-danger-alert">
          <img src="/images/info-red.svg" alt="error">
          <span class="text">
            {{ 'common.text_select_you_can_upload' | cxTranslate }}
          </span>
        </div>
        <div *ngIf="isDuplicateFileIntellipark" class="popup-alert-msg files-danger-alert-duplicate">
          <img src="/images/info-red.svg" alt="info">
          <span class="text">
            {{ 'common.text_warranty_duplicate_file_error' | cxTranslate }}
          </span>
        </div>
        <p>{{ 'common.text_select_you_path_upload' | cxTranslate }}</p>
        <p></p>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-9">
            <!--  <input type="file" #file (input)="fileSelectorFLC(file, 'Bendix® FLC-20™ Camera (Black)')" accept="image/*"
              class="form-control warranty-fileUpload warranty-fileUpload-input input-files-part-no" multiple /> -->
            <input type="file" #intelliparkFileInput (change)="fileSelectorIntellipark(intelliparkFileInput, 'Bendix® Intellipark® Dash ECU (DECU)')"
              accept="image/*" class="form-control warranty-fileUpload warranty-fileUpload-input input-files-part-no"
              multiple />

            <div class="text-danger" *ngIf="errorMsg">{{ errorMsg }}</div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 upload-btn-block">
            <button class="btn btn-primary blue-btn create-file-data-btn uploadAttachment"
              (click)="fileUploadFunctionIntellipark()" type="button" [disabled]="isAtleastOnefileIsThereIntellipark">
              {{ 'common.text_warranty_button_uploadFile' | cxTranslate }}
            </button>
          </div>
        </div>
        <div class="warranty-upload-note">
          {{ 'ECUForm.text_ecu_select_file_type_upload_1' | cxTranslate }}<br>
        </div>
        <div class="popup-upload-fileLists">
          <div *ngIf="fileLengthIntellipark$|async as filecountIntellipark ; else noFiles" class="upload-fileList-result">
            {{ 'common.text_select_you_record_sets' | cxTranslate }}
            <span class="upload-fileList-result-number">{{ filecountIntellipark }}</span>
          </div>
          <ng-template #noFiles>
            <div class="upload-fileList-result">
              {{ 'common.text_select_you_record_sets' | cxTranslate }}
              <span class="upload-fileList-result-number">0</span>
            </div>
          </ng-template>
          <ul>
            <li class="hidden-xs hidden-sm">
              <ul class="item__list--header upload-table-labels">
                <li class="item__sort">#</li>
                <li class="item__name">{{ 'common.text_warranty_name' | cxTranslate }}</li>
                <li class="item__size">{{ 'common.text_warranty_size' | cxTranslate }}</li>
                <li class="item__remove"></li>
              </ul>
            </li>
            <li class="item__list--item js-li-container upload-block">
              <ng-container *ngIf="fileCurrentFilesIntellipark$|async as currentFilesIntellipark">
                <ul class="fileList" *ngFor="let file of currentFilesIntellipark;let i= index">
                  <li>
                    <div class="item__sort">{{ i+1 }}</div>
                    <div class="item__name">{{currentFilesIntellipark[i].name}}</div>
                    <div class="item__size">{{currentFilesIntellipark[i].size | number : '1.2-2'}}Kb</div>
                    <div class="removeFile">
                      <button class="btn btn-link" (click)="removefileIntellipark(file)">
                        {{ 'common.text_remove' | cxTranslate }}
                      </button>
                    </div>
                  </li>
                </ul>
              </ng-container>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Popup for DTC -->
<div class="popup-backdrop" *ngIf="popupOpenDTC"></div>

<div class="popup-modal" *ngIf="popupOpenDTC">
  <div class="popup-header">
    <button class="close-btn" aria-label="close dialog" (click)="closePopupDTC()">
      <img src="/icons/close-light-grey.svg" alt="" />
    </button>
  </div>

  <div class="popup-body">
    <span class="popup-title">{{'ECUForm.dtc_report_text_popup'|cxTranslate}}</span>
    <p class="mt-3">{{'ECUForm.dtc_report_text_popup_title'|cxTranslate}}</p>
  </div>
</div>

<!-- Popup for serial number-->
<div class="popup-backdrop" *ngIf="popupOpenSerialNumber"></div>

<div class="popup-modal" *ngIf="popupOpenSerialNumber">
  <div class="popup-header">
    <button class="close-btn" aria-label="close dialog" (click)="closePopupSerialNumber()">
      <img src="/icons/close-light-grey.svg" alt="" />
    </button>
  </div>

  <div class="popup-body">
    <span class="popup-title">{{'ECUForm.ecu_serial_popup'|cxTranslate}}</span>
    <p class="mt-3">{{'ECUForm.ecu_serial_popup_title'|cxTranslate}}</p>
  </div>
</div>

<!-- Popup for ECU photo -->
<div class="popup-backdrop" *ngIf="popupOpenECUPhoto"></div>

<div class="popup-modal" *ngIf="popupOpenECUPhoto">
  <div class="popup-header">
    <button class="close-btn" aria-label="close dialog" (click)="closePopupECUPhoto()">
      <img src="/icons/close-light-grey.svg" alt="" />
    </button>
  </div>

  <div class="popup-body">
    <span class="popup-title">{{'ECUForm.ecu_photo_popup'|cxTranslate}}</span>
    <p class="mt-3">{{'ECUForm.ecu_photo_popup_title'|cxTranslate}}</p>
  </div>
</div>